import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Restaurant.css';
import RestaurantsList from '../../../../components/SiteAdmin/ManageShop/RestaurantsList'
import getAllShops from './getAllShops.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import Loader from '../../../../components/Common/Loader';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../../locale/messages';

class Restaurant extends React.Component {

  static defaultProps = {
    restaurantDetails: {
      loading: true
    }
  }

  render() {
    const { title, restaurantDetails, restaurantDetails: { loading } } = this.props;
    
    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>
            <FormattedMessage {...messages.manageRestaurantsHeading} />
            </div>
            <div className={s.paddingRoutesSection}>
            { !loading && <RestaurantsList restaurantDetails={restaurantDetails} /> }
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllShops, {
    name: 'restaurantDetails',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchList: ''
      }
    }
  })
)(Restaurant);
